var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ErrorHandler from '@/support/ErrorHandler';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { Event as EventModel } from '@/models/Event';
import { formatDate as format } from '@/support/String';
import DataTable from '@/components/data-table/DataTable';
import { Activity } from '@/models/Activity';
import CreateActivityDialog from '@/views/RosterTemplates/CreateActivityDialog';
import CreateRecessDialog from '@/views/RosterTemplates/CreateRecessDialog';
import { Timeslot } from '@/models/Timeslot';
import { reverseDayMap } from '@/support/CalendarDefaults';
let ShowActivitiesDialog = class ShowActivitiesDialog extends Vue {
    constructor() {
        super(...arguments);
        this.visibility = {
            checkboxes: false,
            search: false,
        };
        this.isCreatingActivityDialog = false;
        this.isCreatingRecessDialog = false;
        this.newTimeSlot = null;
        this.isEditingStartDate = false;
        this.isEditingEndDate = false;
        this.isEditingEvent = false;
        this.selectedEventStartTime = null;
        this.parsedEventStartTime = '';
        this.eventStartTimeModal = '';
        this.editingEventStart = false;
        this.selectedEventEndTime = null;
        this.parsedEventEndTime = '';
        this.eventEndTimeModal = '';
        this.editingEventEnd = false;
        this.selectedEventTime = null;
        this.selectedActivity = null;
        this.selectedTimeSlot = null;
        this.timeslotChanged = false;
        this.formattedTimeSlotDay = '';
        this.refreshCreateDialog = false;
        this.showAudits = false;
        this.audits = [];
    }
    get deleteTimeSlot() {
        return {
            title: 'timeslot' || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.timeslot') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!this.newTimeSlot) {
                            return;
                        }
                        this.newTimeSlot
                            .delete()
                            .then(() => {
                            this.$emit('timeslotRemoved');
                            this.$emit('input', false);
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedTimeSlot = null;
                    },
                },
            },
        };
    }
    get tableOptionsActivities() {
        return {
            name: {
                singular: this.$tc('rosterTemplate.dialog.header.activities', 1),
                plural: this.$tc('rosterTemplate.dialog.header.activities', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'timeslots',
                    width: '3px',
                    style: { position: 'relative' },
                    transform: (value, activity) => {
                        return activity.meta && activity.meta.totals && activity.meta.totals.timeslots > 1 ? `<div class="doublePeriodLine"></div>` : '';
                    },
                },
                {
                    text: '',
                    value: 'avatar',
                    transform: (value, activity) => {
                        if (!activity.teacher) {
                            return '';
                        }
                        return `<img class="avatar avatar-small" src="${activity.teacher.avatar}">`;
                    },
                },
                {
                    text: this.$tc('roles.teacher', 1),
                    value: 'users',
                    transform: (users) => {
                        let str = '';
                        users.forEach((user) => { str += `${user.name}, `; });
                        return str.substring(0, str.length - 2);
                    },
                },
                {
                    text: this.$tc('subject.area.title', 1),
                    value: 'areas',
                    transform: (areas, activity) => {
                        if (activity.type === 'recess') {
                            return this.$t('rosterTemplate.recess').toString();
                        }
                        let str = '';
                        areas.forEach((area) => { str += `${area.name}, `; });
                        return str.substring(0, str.length - 2);
                    },
                },
                {
                    text: this.$tc('subject.topic.title', 1),
                    value: 'topics',
                    transform: (topics, activity) => {
                        if (activity.type === 'recess') {
                            return '';
                        }
                        let str = '';
                        topics.forEach((topic) => { str += `${topic.name}, `; });
                        return str.substring(0, str.length - 2);
                    },
                },
                {
                    text: this.$tc('room.title', 1),
                    value: 'room',
                    transform: (room) => {
                        return room.name;
                    },
                },
                {
                    text: this.$tc('level.title', 2),
                    value: 'levels',
                    transform: (levels) => {
                        let str = '';
                        levels.forEach((level) => { str += `${level.name}, `; });
                        return `<span class="${levels[0] && levels[0].is_mandatory ? 'is_mandatory' : ''}">${str.substring(0, str.length - 2)}</span>`;
                    },
                },
                {
                    text: this.$tc('group.title', 2),
                    value: 'groups',
                    transform: (groups) => {
                        let str = '';
                        groups.forEach((group) => { str += `${group.name}, `; });
                        return `<span class="${groups[0] && groups[0].is_mandatory ? 'is_mandatory' : ''}">${str.substring(0, str.length - 2)}</span>`;
                    },
                },
            ],
            actions: [
                {
                    type: 'edit',
                    label: 'edit',
                    icon: 'edit',
                    action: (vm, activity) => {
                        this.selectedActivity = activity;
                        this.refreshCreateDialog = true;
                        this.selectedActivity.type === 'lesson' ? this.isCreatingActivityDialog = true : this.isCreatingRecessDialog = true;
                    },
                },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, activity) => {
                        this.handleTableDelete(activity);
                    },
                },
            ],
            filters: [],
            model: new Activity().include(['users', 'teacher', 'areas', 'topics', 'levels', 'groups', 'room', 'meta']).filter('timeslots', [this.timeslot.id] || []),
        };
    }
    get weekDays() {
        return [
            {
                key: 'monday',
                title: this.$t('weekDays.monday').toString(),
            },
            {
                key: 'tuesday',
                title: this.$t('weekDays.tuesday').toString(),
            },
            {
                key: 'wednesday',
                title: this.$t('weekDays.wednesday').toString(),
            },
            {
                key: 'thursday',
                title: this.$t('weekDays.thursday').toString(),
            },
            {
                key: 'friday',
                title: this.$t('weekDays.friday').toString(),
            },
            {
                key: 'saturday',
                title: this.$t('weekDays.saturday').toString(),
            },
            {
                key: 'sunday',
                title: this.$t('weekDays.sunday').toString(),
            },
        ];
    }
    get auditCount() {
        let errorCount = 0;
        let warningCount = 0;
        if (this.audits.length) {
            this.audits.forEach((audit) => {
                if (audit.severity === 'error') {
                    errorCount += 1;
                }
                else if (audit.severity === 'warning') {
                    warningCount += 1;
                }
            });
        }
        return {
            total: errorCount + warningCount,
            errors: errorCount,
            warnings: warningCount,
        };
    }
    get activitiesDataTable() {
        const dataTable = this.$refs.activitiesDataTable;
        if (dataTable) {
            return dataTable;
        }
        return null;
    }
    get deleteActivity() {
        const activity = this.selectedActivity;
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.activity') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!activity) {
                            return;
                        }
                        activity
                            .delete()
                            .then(() => {
                            this.selectedActivity = null;
                            this.refreshDataTable();
                            this.$emit('activityRemoved');
                            this.timeslotChanged = true;
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedActivity = null;
                    },
                },
            },
        };
    }
    mounted() {
        this.timeslotChanged = false;
        this.initialize();
    }
    initialize() {
        this.formatTimeSlotDay();
    }
    close() {
        if (this.timeslotChanged) {
            this.$emit('refreshEvents');
        }
        this.$emit('input', false);
        this.clear();
    }
    clear() {
        this.newTimeSlot = new EventModel();
        this.showAudits = false;
    }
    refreshDataTable() {
        this.timeslotChanged = true;
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    timeslotsForDay(day) {
        day = parseInt(day);
        const test = this.timeslots.filter((timeslot) => {
            const filterDay = parseInt(timeslot.day || '0');
            return filterDay === day;
        });
        return test;
    }
    update() {
        if (!this.newTimeSlot) {
            return;
        }
        this.newTimeSlot
            .update()
            .then((timeslot) => {
            this.newTimeSlot = timeslot.clone();
            this.$emit('timeslotUpdated', timeslot);
            this.isEditingEvent = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
        this.clear();
    }
    remove() {
        this.$store.dispatch('openDialog', this.deleteTimeSlot);
    }
    cancel() {
        this.isEditingEvent = false;
    }
    formatTimeSlotDay() {
        if (!this.newTimeSlot) {
            return;
        }
        this.weekDays.find((weekDay) => {
            if (reverseDayMap[this.newTimeSlot.day] === weekDay.key) {
                return this.formattedTimeSlotDay = weekDay.title;
            }
        });
    }
    handleTableDelete(activity) {
        this.selectedActivity = activity;
        this.$store.dispatch('openDialog', this.deleteActivity);
    }
    parseAuditMessage(audit) {
        if (!audit.code) {
            return '';
        }
        let message = '';
        let name = '';
        switch (audit.code) {
            case 'activity.missing':
                message = this.$t(`rosterAudits.${audit.code}`).toString();
                break;
            case 'event.missing':
                message = this.$t(`rosterAudits.${audit.code}`).toString();
                break;
            case 'teacher.absent':
                message = this.$t(`rosterAudits.${audit.code}`).toString();
                break;
            case 'teacher.occupied':
                name = audit.meta && audit.meta.teacher && audit.meta.teacher.name ? audit.meta.teacher.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'teacher.occupied':
                name = audit.meta && audit.meta.teacher && audit.meta.teacher.name ? audit.meta.teacher.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'teacher.vacation':
                name = audit.meta && audit.meta.teacher && audit.meta.teacher.name ? audit.meta.teacher.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'group.occupied':
                name = audit.meta && audit.meta.group && audit.meta.group.name ? audit.meta.group.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'group.unassigned':
                name = audit.meta && audit.meta.group && audit.meta.group.name ? audit.meta.group.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'group.missing':
                name = audit.meta && audit.meta.group && audit.meta.group.name ? audit.meta.group.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'group.recess':
                name = audit.meta && audit.meta.level && audit.meta.level.name ? audit.meta.level.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'level.occupied':
                name = audit.meta && audit.meta.level && audit.meta.level.name ? audit.meta.level.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'level.unassigned':
                name = audit.meta && audit.meta.level && audit.meta.level.name ? audit.meta.level.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'level.missing':
                name = audit.meta && audit.meta.level && audit.meta.level.name ? audit.meta.level.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'level.recess':
                name = audit.meta && audit.meta.level && audit.meta.level.name ? audit.meta.level.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'room.occupied':
                name = audit.meta && audit.meta.room && audit.meta.room.name ? audit.meta.room.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            default:
                break;
        }
        return message;
    }
    fetchAudits() {
        if (!this.timeslot || !this.timeslot.id) {
            return;
        }
        this.audits = [];
        this.timeslot
            .audit()
            .then((audits) => {
            this.audits = audits;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    refetch() {
        this.activitiesDataTable ? this.activitiesDataTable.refresh() : null;
        this.fetchAudits();
    }
    dialogChanged(isOpen) {
        if (!isOpen) {
            this.selectedActivity = null;
            this.refreshCreateDialog = false;
        }
    }
    timeslotChanges(timeslot) {
        if (timeslot) {
            this.newTimeSlot = timeslot.clone();
            this.fetchAudits();
            this.formatTimeSlotDay();
            if (this.newTimeSlot) {
                this.newTimeSlot.starts_at = format(timeslot.starts_at || '', 'HH:mm');
                this.newTimeSlot.ends_at = format(timeslot.ends_at || '', 'HH:mm');
            }
        }
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", typeof (_a = typeof Timeslot !== "undefined" && Timeslot) === "function" ? _a : Object)
], ShowActivitiesDialog.prototype, "timeslot", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], ShowActivitiesDialog.prototype, "timeslots", void 0);
__decorate([
    Watch('isCreatingActivityDialog'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ShowActivitiesDialog.prototype, "dialogChanged", null);
__decorate([
    Watch('timeslot'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof Timeslot !== "undefined" && Timeslot) === "function" ? _b : Object]),
    __metadata("design:returntype", void 0)
], ShowActivitiesDialog.prototype, "timeslotChanges", null);
ShowActivitiesDialog = __decorate([
    Component({
        components: {
            SelectFilter,
            DataTable,
            CreateActivityDialog,
            CreateRecessDialog,
        },
        filters: {
            formatDate(date) {
                return !date ? '' : format(date, 'dd-LL-yyyy');
            },
            formatTime(time) {
                return !time ? '' : format(time, 'HH:mm');
            },
            formatDay(day) {
                return reverseDayMap[day];
            },
        },
    })
], ShowActivitiesDialog);
export default ShowActivitiesDialog;
